import { ExternalSuppliersFormOptions } from "@/redux/slices/externalSupplier/types";
import { GetExternalSupplierProfileRawResponse, GetExternalSupplierProfileResponse, GetExternalSuppliersFormOptionsRawResponse, GetExternalSuppliersRawResponse, GetExternalSuppliersResponse } from "./types";

export const transformExternalSuppliers = (res: GetExternalSuppliersRawResponse) => {
  const {
    _embedded: { external_supplier: suppliers },
    page,
    page_count,
    page_size,
    total_items,
  } = res;

  const response: GetExternalSuppliersResponse = {
    data: {
      suppliers: suppliers.map((i) => ({
        id: i.uuid,
        name: i.name,
        email: i.email,
        type: i.type,
        phone: i.phone,
        state: i.state[0],
        status: i.status,
        avatar: i.avatar ?? "",
        profileCompletion: Math.floor(i.metadata.profile_completion / 100),
        rating: i.metadata.rating,
      })),
      page: {
        current: page,
        count: page_count,
        size: page_size,
        total: total_items,
      },
    },
  };

  return response;
};

export const transformExternalSuppliersFormOptions = (res: GetExternalSuppliersFormOptionsRawResponse) => {
  const { account_status, address_state, type, rating } = res;

  const response: ExternalSuppliersFormOptions = {
    ratings: Object.entries(rating).map((i) => ({ name: i[1], value: i[0] })),
    states: Object.entries(address_state).map((i) => ({ name: i[1], value: i[0] })),
    statuses: Object.entries(account_status).map((i) => ({ name: i[1], value: i[0] })),
    types: Object.entries(type).map((i) => ({ name: i[1], value: i[0] })),
  };

  return response;
};

export const transformExternalSupplierProfile = (res: GetExternalSupplierProfileRawResponse) => {
  const { address, rating, region_au } = res;
  const response: GetExternalSupplierProfileResponse = {
    id: res.uuid,
    name: res.name,
    type: res.type,
    email: res.email,
    phone: res.phone,
    state: res.state,
    status: res.status,
    address: {
      address: address.address,
      city: address.city,
      postCode: address.post_code,
      state: address.state,
      country: address.country,
      lat: address.lat,
      lng: address.lng,
    },
    keyContactName: res.key_contact_name,
    rating: {
      rating: rating.rating,
      jobsCompleted: rating.jobs_completed,
    },
    regionAu: {
      abn: region_au.abn,
      isGstRegistered: region_au.is_gst_registered,
    },
    avatar: res.avatar,
  };

  return response;
};